<form name="imagesForm" #imagesForm="ngForm" novalidate [formGroup]="form">
  <mat-card>
    <h3>Images</h3>
    <p>Please supply up to six images, not all images will be accepted, please consult our
      <a (click)="openImageGuidelines()">guidelines</a> to ensure all images get featured on your listing.
    </p>

    <!-- Drag & Drop Upload Area -->
    <div class="upload-area"
         [class.drag-over]="isDragOver"
         (dragover)="onDragOver($event)"
         (dragleave)="onDragLeave($event)"
         (drop)="onDrop($event)"
         *ngIf="uploadedMedia.length < maxImages">
      <div class="upload-area__content">
        <mat-icon class="upload-area__icon">cloud_upload</mat-icon>
        <p class="upload-area__text">Drag & drop images here</p>
        <p class="upload-area__or">or</p>
        <button mat-raised-button color="primary" type="button" (click)="fileInput.click()">
          Browse Files
        </button>
        <input #fileInput type="file" hidden multiple
               accept=".jpg,.jpeg,.png,.gif,.webp"
               (change)="onFilesSelected($event)">
        <p class="upload-area__hint">JPG, PNG, GIF or WebP. Max 2MB per file. Up to {{maxImages}} images.</p>
      </div>
    </div>

    <mat-spinner [diameter]="40" *ngIf="pendingCount > 0"></mat-spinner>

    <p class="no-image error-text" *ngIf="form.get('atLeastOneImage')?.touched && form.get('atLeastOneImage')?.invalid">
      At least one image is required.
    </p>

    <!-- Uploaded Images List -->
    <div class="uploaded-images">
      <div class="image-card" [class.image-card--primary]="i === 0" *ngFor="let file of uploadedMedia; let i = index">
        <div class="image-card__left">
          <div class="image-card__preview">
            <img [src]="file.url" [alt]="file.title || 'Uploaded image'" class="image-card__img">
            <span class="image-card__primary-badge" *ngIf="i === 0">
              <mat-icon class="image-card__primary-badge-icon">star</mat-icon> Primary Image
            </span>
          </div>
          <p class="image-card__primary-hint" *ngIf="i === 0">Will appear in search results, listings etc.</p>
          <button mat-stroked-button class="image-card__make-primary" (click)="makePrimary(i)"
                  type="button" *ngIf="i > 0">
            <mat-icon>star_border</mat-icon> Make Primary
          </button>
          <button mat-flat-button color="warn" class="image-card__delete" (click)="removeImage(i)"
                  type="button">
            Remove Image
          </button>
        </div>
        <div class="image-card__details">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Image Title</mat-label>
            <input matInput [formControlName]="file.titleName"
                   (input)="file.title = $any($event.target).value"
                   (focusout)="trimValue($event, file.titleName)">
            <mat-hint>Please provide a title for the image (25-50 characters).</mat-hint>
            <mat-error *ngIf="form.get(file.titleName)?.invalid">
              {{getErrorMessage(file.titleName)}}
            </mat-error>
          </mat-form-field>
          <div class="char-count">{{ file.title?.length || 0 }} / 50 characters</div>

          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Image Description</mat-label>
            <input matInput [formControlName]="file.descriptionName"
                   (input)="file.description = $any($event.target).value"
                   (focusout)="trimValue($event, file.descriptionName)">
            <mat-hint>Please provide a description for the image (25-240 characters).</mat-hint>
            <mat-error *ngIf="form.get(file.descriptionName)?.invalid">
              {{getErrorMessage(file.descriptionName)}}
            </mat-error>
          </mat-form-field>
          <div class="char-count">{{ file.description?.length || 0 }} / 240 characters</div>
        </div>
      </div>
    </div>
  </mat-card>
</form>